const userGroups = {
  tech: [
    'daniel.pesch@erste-hausverwaltung.de',
    'kalliopi.misiou@erste-hausverwaltung.de',
    'pascal.kumpf@erste-hausverwaltung.de',
    'mohamed.sofi@erste-hausverwaltung.de',
    'ben.craddock@erste-hausverwaltung.de',
    'justus.mentzel@erste-hausverwaltung.de',
    'vincenz.busch@workingsoftware.io',
    'dominik.schmithausen@erste-hausverwaltung.de',
    'bhargavi.chirumamilla@erste-hausverwaltung.de',
    'malek.abdelkader@erste-hausverwaltung.de',
    'florian.pullem@erste-hausverwaltung.de',
    'florian.pullem@web.de',
    'verena.schwanck@erste-hausverwaltung.de',
    'felix.ritschel@erste-hausverwaltung.de',
    'khaled.selmi@erste-hausverwaltung.de',
    'chibuike.dialaekwe@erste-hausverwaltung.de',
    'pascal.ambrosius@erste-hausverwaltung.de',
    'pa@ehv.de',
  ],
  zhv: [
    'c.junker@hv-zieglmeier.de',
    'c.appel@hv-zieglmeier.de',
    'e.stey@hv-zieglmeier.de',
    'g.kohnle@hv-zieglmeier.de',
    'i.hautz@hv-zieglmeier.de',
    'j.simic@hv-zieglmeier.de',
    'k.boehme@hv-zieglmeier.de',
    'lars.zieglmeier@hv-zieglmeier.de',
    'm.martin@hv-zieglmeier.de',
    'm.gmeiner@hv-zieglmeier.de',
    's.hadria@hv-zieglmeier.de',
    't.gruener@hv-zieglmeier.de',
    'v.kucheriava@hv-zieglmeier.de',
    'm.dokl@hv-zieglmeier.de',
  ],
  capitol: [
    'aurelius.rus@erste-hausverwaltung.de',
    'r.wolff@capitol.de',
    'l.kirchmann@capitol.de',
    'm.czerepak@capitol.de',
    's.reisyan@capitol.de',
    's.ahrens@capitol.de',
    'b.esposito@capitol.de',
    'h.hallaschek@capitol.de',
    's.chennour@capitol.de',
    'b.meissner@capitol.de',
    'k.beslagic@capitol.de',
    'm.krebs@capitol.de',
    'a.cakolli@capitol.de',
    's.mohamad@capitol.de',
  ],
  ehvd: [
    'till.fleitmann@erste-hausverwaltung.de',
    'marc.somers@erste-hausverwaltung.de',
    'robin.werkmeister@erste-hausverwaltung.de',
    'michelle.gorgas@erste-hausverwaltung.de',
    'lorena.gentilezza@erste-hausverwaltung.de',
    'info@se-immo-service.de',
    'ebner@akkurat-abrechnung.de',
    'rachwalski@akkurat-abrechnung.de',
    'cordes@akkurat-abrechnung.de',
    'born@akkurat-abrechnung.de',
    'ownr@erste-hausverwaltung.de',
  ],
  sgv: [
    'iris.koenig@sgv-murr.de',
    'michelle.vogt@sgv-murr.de',
    'kirsten.koehler@sgv-murr.de',
    'olga.goedecke@sgv-murr.de',
    'kristina.leibfarth@sgv-murr.de',
    'sandra.schrempf@sgv-murr.de',
    'kerstin.haase@sgv-murr.de',
    'andreas.baeuerle@sgv-murr.de',
    'jochen.watzl@sgv-murr.de',
  ],
  verwey: [
    'anne-kareen.krueger@verwey-gmbh.de',
    'bianka.schueler@verwey-gmbh.de',
    'christine.gillessen@verwey-gmbh.de',
    'christopher.bens@verwey-gmbh.de',
    'frank.ebel@verwey-gmbh.de',
    'fynn.leimkoetter@verwey-gmbh.de',
    'kelvin.olatunbosun@verwey-gmbh.de',
    'kirstin.jansen@verwey-gmbh.de',
    'kurt.damerau@verwey-gmbh.de',
    'markus.rupar@verwey-gmbh.de',
    'michael.honnen@verwey-gmbh.de',
    'ramona.mund@verwey-gmbh.de',
    'sandra.huppers@verwey-gmbh.de',
    'simone.weiss@verwey-gmbh.de',
    'stefan.piotrowski@verwey-gmbh.de',
    'volker.quante@verwey-gmbh.de',
    'felix.schulte@verwey-gmbh.de',
    'philipp.lukas@verwey-gmbh.de',
    'marko.doernemann@verwey-gmbh.de',
    'kerstin.kaczor@verwey-gmbh.de',
  ],
  hv_tesche: [
    'alena.mader@hv-tesche.de',
    'birgit.doernbrack@hv-tesche.de',
    'dennis.plinius@hv-tesche.de',
    'elke.koehler@hv-tesche.de',
    'joerg.vanheek@hv-tesche.de',
    'johanna.radomski@hv-tesche.de',
    'larissa.osthoff@hv-tesche.de',
    'nelli.deisling@hv-tesche.de',
    'oliver.rosenberg@hv-tesche.de',
    'pascal-marcel.planz@hv-tesche.de',
    'ralf.wynants@hv-tesche.de',
    'silvia.bickmann@hv-tesche.de',
    'tina.braun@hv-tesche.de',
    'vanessa.glodowski@hv-tesche.de',
  ],
  hv_tesche_buha: [
    'alena.mader@hv-tesche.de',
    'johanna.radomski@hv-tesche.de',
    'silvia.bickmann@hv-tesche.de',
    'kurt.damerau@verwey-gmbh.de',
    'kirstin.jansen@verwey-gmbh.de',
  ],
  internal_accounting_team: [
    'sandra.dietze@erste-hausverwaltung.de',
    'doreen.kliebisch@erste-hausverwaltung.de',
  ],
  ehv_service: [
    'tim.schneider@erste-hausverwaltung.de',
    'doreen.kliebisch@erste-hausverwaltung.de',
  ],
  zenit: [
    'goran.jancic@zenit-immobilien.de',
    'matthias.lalla@zenit-immobilien.de',
  ],
  accounting: [
    'kalliopi.misiou@erste-hausverwaltung.de',
    'info@se-immo-service.de',
    'linda.trenz@erste-hausverwaltung.de',
    'doreen.kliebisch@erste-hausverwaltung.de',
    'witta.rumpel@erste-hausverwaltung.de',
    'sandra.dietze@erste-hausverwaltung.de',
  ],
  bank_transaction_balances: [
    'info@se-immo-service.de',
    'sandra.dietze@erste-hausverwaltung.de',
    'linda.trenz@erste-hausverwaltung.de',
    'doreen.kliebisch@erste-hausverwaltung.de',
    'witta.rumpel@erste-hausverwaltung.de',
    'pascal.kumpf@erste-hausverwaltung.de',
    'verena.schwanck@erste-hausverwaltung.de',
    'florian.pullem@erste-hausverwaltung.de',
    'justus.mentzel@erste-hausverwaltung.de',
    'daniel.pesch@erste-hausverwaltung.de',
  ],
  managing_director: [
    'marc.somers@erste-hausverwaltung.de',
    'aurelius.rus@erste-hausverwaltung.de',
    'boris.mueller@erste-hausverwaltung.de',
    'kalliopi.misiou@erste-hausverwaltung.de',
    's.grass@bhv-group.de',
    'r.michallek@bhv-group.de',
    'andreas.baeuerle@sgv-murr.de',
    'kerstin.haase@sgv-murr.de',
    'k.boehme@hv-zieglmeier.de',
    'stefan.piotrowski@verwey-gmbh.de',
    'simone.weiss@verwey-gmbh.de',
    'joerg.vanheek@hv-tesche.de',
    'vanessa.glodowski@hv-tesche.de',
  ],
  leadership: [
    'marc.somers@erste-hausverwaltung.de',
    'aurelius.rus@erste-hausverwaltung.de',
    'a.rus@capitol.de',
    'l.kirchmann@capitol.de',
    'boris.mueller@erste-hausverwaltung.de',
    'kalliopi.misiou@erste-hausverwaltung.de',
    'k.boehme@hv-zieglmeier.de',
    'andreas.baeuerle@sgv-murr.de',
    'kerstin.haase@sgv-murr.de',
    'stefan.piotrowski@verwey-gmbh.de',
    'simone.weiss@verwey-gmbh.de',
    'joerg.vanheek@hv-tesche.de',
    'vanessa.glodowski@hv-tesche.de',
    'kurt.damerau@verwey-gmbh.de',
    'kirstin.jansen@verwey-gmbh.de',
    's.grass@bhv-group.de',
    'r.michallek@bhv-group.de',
  ],
  demo: ['a.benz@benz-walker.de', 't.reuter@benz-walker.de'],
  benz_walker: [
    'sm.wonney@benz-walker.de',
    'd.balcik@benz-walker.de',
    'e.zimmermann@benz-walker.de',
    'i.walker@benz-walker.de',
    'j.rathgeb@benz-walker.de',
    'k.kotsch@benz-walker.de',
    'l.sattler@benz-walker.de',
    'l.bader-schatz@benz-walker.de',
    'n.beicht@benz-walker.de',
    'p.lopes@benz-walker.de',
    'p.beifuss@benz-walker.de',
    's.bisinger@benz-walker.de',
    'v.fernandes@benz-walker.de',
    's.schmidt@benz-walker.de',
    't.reuter@benz-walker.de',
  ],
  fraenken: [
    'andrea.reiff@fraenken.de',
    'boris.mueller@fraenken.de',
    'cornelia.becker@fraenken.de',
    'silke.fellenberg@fraenken.de',
    'magnus.grocholl@fraenken.de',
    'marion.kotalla@fraenken.de',
    'michael.tuebben@fraenken.de',
    'hildegard.susok@fraenken.de',
    'tetiana.pavlenko@fraenken.de',
    'sandra.wagner@fraenken.de',
  ],
  bhv: [
    'd.hoddenkamp@bhv-group.de',
    'e.weintritt@bhv-group.de',
    'j.draeger@bhv-group.de',
    'f.kandale@bhv-group.de',
    'b.block@bhv-group.de',
    's.grass@bhv-group.de',
    'r.michallek@bhv-group.de',
    'n.michallek@bhv-group.de',
    'n.natzke@bhv-group.de',
    's.trefflich@bhv-group.de',
    's.schoeps@bhv-group.de',
    'p.justus@bhv-group.de',
    'd.wunderlich@bhv-group.de',
    'c.hellfach@bhv-group.de',
    'm-michallek@bhv-group.de',
    'm.saal@bhv-group.de',
    'it@bhv-group.de',
  ],
  invoice_creation: [
    's.schoeps@bhv-group.de',
    'p.justus@bhv-group.de',
    's.trefflich@bhv-group.de',
    's.grass@bhv-group.de',
    'r.michallek@bhv-group.de',
    'm.saal@bhv-group.de',
    'n.michallek@bhv-group.de',
    'n.natzke@bhv-group.de',
    'c.hellfach@bhv-group.de',
    'ramona.mund@verwey-gmbh.de',
  ],
  /** Sees the upcoming appointments card on the dashboard. */
  appointments: [],
  /** Sees the open invoices / open documents (OpsReporting) card on the dashboard. */
  ops_reporting: ['ramona.mund@verwey-gmbh.de'],

}

const getUserRoles = (userEmail) => {
  const roles = []
  for (const [role, emails] of Object.entries(userGroups)) {
    if (emails.includes(userEmail)) {
      roles.push(role)
    }
  }
  return roles.length > 0 ? roles : ['user']
}

const isInRole = (role) => {
  const email = JSON.parse(localStorage.getItem('auth'))?.email || null
  if (!email) return false
  const roles = getUserRoles(email)
  return roles.includes(role)
}

// Make isInRole globally available
window.isInRole = isInRole
